import { createSlice } from '@reduxjs/toolkit';


const initialState = {
  activeTabLabel: '',
  userData: null,
  cameraData: [],
  vehicleEntries: [],
  isLoadingVehicleEntries: false,
  vehicleNumberMismatch: { sap_vnum: '', ai_vnum: '' },
  userVehicleMappingId: null,
  soundTypes: [],
  userRoles: []
};

const allDataSlice = createSlice({
  name: 'data',
  initialState,
  reducers: {
    setActiveTabLabel: (state, action) => {
      state.activeTabLabel = action.payload;
    },
    setUserData: (state, action) => {
      state.userData = action.payload;
    },
    setUserRoles: (state, action) => {
      state.userRoles = action.payload;
    },
    setCameraData: (state, action) => {
      state.cameraData = action.payload
    },
    setVehicleEntriesData: (state, action) => {
      state.vehicleEntries = action.payload
    },
    setSoundTypes: (state, action) => {
      state.soundTypes = action.payload;
    },
    setVehicleNumberMismatch: (state, action) => {
      state.vehicleNumberMismatch = { sap_vnum: action.payload.sap_vnum || '', ai_vnum: action.payload.ai_vnum || '' }
    },
    setUserVehicleMappingId: (state, action) => { state.userVehicleMappingId = action.payload; }
  }
});

export const { setActiveTabLabel, setUserData, setCameraData, setVehicleEntriesData, setVehicleNumberMismatch, setUserVehicleMappingId, setSoundTypes, setUserRoles } = allDataSlice.actions;

export default allDataSlice.reducer;